<template>
  
    <v-app>
      <v-main>
        <GuidanceValues/>
      </v-main>
    </v-app>
</template>

<script>
import GuidanceValues from "@/components/GuidanceValues";

export default {
  name: 'App',

  components: {
    GuidanceValues,
  },

  data: () => ({
    //
  }),
};
</script>
